// JS.
import {IconicGTMPurchase} from './gtm-purchase.js';
import {IconicAffWPPurchase} from './affwp-purchase.js';
import {IconicImpactPurchase} from './impact-purchase.js';
import {IconicHelpers} from './helpers.js';

/**
 * Set up checkout.
 */
class IconicCheckout {
	/**
	 * Freemius handler.
	 *
	 * @type {null}
	 */
	checkoutHandler = null;

	/**
	 * Class names.
	 *
	 * @type {{}}
	 */
	classes = {
		price: '.iconic-dynamic-price',
		buttonWrap: '.iconic-buy-button',
		sites: '.iconic-buy-button__sites',
		cycle: '.iconic-price-cycle-switch',
		sitesText: '.iconic-sites-text',
		buyButton: '.iconic-buy-button__button'
	};

	/**
	 * Run checkout.
	 */
	constructor() {
		this.watchCycle();
		this.watchSites();
	};

	/**
	 * Watch cycle selector.
	 */
	watchCycle = () => {
		document.querySelectorAll( this.classes.cycle ).forEach( ( cycle ) => {
			let toggle = cycle.querySelector( '.iconic-switch__checkbox' ),
				labels = cycle.querySelectorAll( this.classes.cycle + '__label' );

			toggle.addEventListener( 'change', ( e ) => {
				let productId = parseInt( cycle.dataset.iconicProductId ),
					selectedCycle = toggle.checked ? 'annual' : 'monthly';

				labels.forEach( ( label ) => {
					label.classList.toggle( this.classes.cycle.replace( '.', '' ) + '__label--active' );
				} );

				this.updatePrice( productId, 1, selectedCycle );
			} );
		} );
	};

	/**
	 * Watch sites selector.
	 */
	watchSites = () => {
		document.querySelectorAll( this.classes.sites ).forEach( ( select ) => {
			select.addEventListener( 'change', ( e ) => {
				let productId = parseInt( select.dataset.iconicProductId );

				// Get sites from selected option, data-iconic-sites as string.
				let sites = select.options[ select.selectedIndex ].dataset.iconicSites;

				this.updatePrice( productId, select.value );
				this.updateSites( productId, select.value, select.options[ select.selectedIndex ].text );
				this.updateBuyUrl( productId, select.value, sites );
			} );
		} );
	};

	/**
	 * Watch buy buttons.
	 */
	watchBuyButtons = () => {
		document.querySelectorAll( this.classes.buyButton ).forEach( ( button ) => {
			button.addEventListener( 'click', ( e ) => {
				e.preventDefault();

				let productId = parseInt( button.dataset.iconicProductId ),
					checkoutArgs = JSON.parse( button.dataset.iconicBuy ),
					cachedCoupon = IconicHelpers.getCookie( 'iconic-coupon' );

				// If it's not 1, then we've specifically set it to something else and it shouldn't change.
				checkoutArgs.licenses = 1 === checkoutArgs.licenses ? this.getSites( productId ) : checkoutArgs.licenses;
				checkoutArgs.billing_cycle = this.getCycle( productId );

				// Add coupon dynamically to bypass page caching.
				if ( '' === checkoutArgs.coupon && cachedCoupon ) {
					checkoutArgs.coupon = cachedCoupon;
				}

				checkoutArgs.purchaseCompleted = function( response ) {
					IconicGTMPurchase.dataLayerPush( response, checkoutArgs.title );
					IconicAffWPPurchase.pushReferral( response, checkoutArgs.title );
					IconicImpactPurchase.pushReferral( response, checkoutArgs.title );
				};

				if ( typeof ga !== "undefined" ) {
					ga( 'send', 'event', 'Plugin', 'Open Checkout - Buy Now', checkoutArgs.title );
				}

				this.checkoutHandler.open( checkoutArgs );
			} );
		} );
	};

	/**
	 * Update price.
	 */
	updatePrice = ( productId, sites = 1, cycle = 'annual' ) => {
		document.querySelectorAll( this.classes.price + '[data-iconic-product-id="' + productId + '"]' ).forEach( ( price ) => {
			let selectedSites = typeof price.dataset.iconicSites !== 'undefined' ? price.dataset.iconicSites : sites,
				prices = JSON.parse( price.dataset.iconicPrices ),
				amount = price.querySelector( this.classes.price + '__price--regular ' + this.classes.price + '__amount' ),
				rrpAmount = price.querySelector( this.classes.price + '__price--rrp ' + this.classes.price + '__amount' ),
				saveAmount = price.querySelector( this.classes.price + '__price--save ' + this.classes.price + '__amount' ),
				cycleText = price.querySelector( this.classes.price + '__cycle' );

			amount.innerHTML = prices[ selectedSites ][ cycle ];

			if ( rrpAmount ) {
				rrpAmount.innerHTML = prices[ selectedSites ][ 'rrp_' + cycle ];
			}

			if ( saveAmount ) {
				saveAmount.innerHTML = Math.round( prices[ selectedSites ][ 'rrp_' + cycle ] - prices[ selectedSites ][ cycle ] );
			}

			if ( cycleText ) {
				cycleText.innerHTML = 'annual' === cycle ? '/year' : '/month';
			}
		} );
	};

	/**
	 * Update sites.
	 */
	updateSites = ( productId, sites, sitesText ) => {
		document.querySelectorAll( this.classes.sites + '[data-iconic-product-id="' + productId + '"]' ).forEach( ( select ) => {
			select.value = sites;
		} );

		document.querySelectorAll( this.classes.sitesText + '[data-iconic-product-id="' + productId + '"]' ).forEach( ( span ) => {
			span.innerHTML = sitesText;
		} );
	};

	/**
	 * Update Buy Now button URL.
	 */
	updateBuyUrl = ( productId, variationId, sites ) => {
		// Find all the buy buttons for the product
		document.querySelectorAll( this.classes.buyButton + '[data-iconic-product-id="' + productId + '"]' ).forEach( ( button ) => {
			// Get the current href
			let currentUrl = new URL( button.href );

			// Modify the URL
			currentUrl.searchParams.set( 'variation_id', variationId );
			currentUrl.searchParams.set( 'attribute_pa_sites', sites );

			// Set the new href
			button.href = currentUrl.toString();
		} );
	};

	/**
	 * Get sites count.
	 */
	getSites = ( productId ) => {
		let sites = document.querySelector( this.classes.sites + '[data-iconic-product-id="' + productId + '"]' );

		return sites ? parseInt( sites.value ) : 1;
	};

	/**
	 * Get cycle.
	 */
	getCycle = ( productId ) => {
		let cycle = document.querySelector( this.classes.cycle + '[data-iconic-product-id="' + productId + '"] .iconic-switch__checkbox' );

		return cycle && ! cycle.checked ? 'monthly' : 'annual';
	};
}

export {IconicCheckout};